import React, { useState } from 'react';
import styled from 'styled-components';

import { Row, Col } from '../../Grid';
import { ClaimNumber, WaitlistInfo } from './Common';
import AttendeeList from '../Partials/AttendeeList';

const InstanceContainer = styled.div`
  background-color: #fafafa;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 2px;
`;

const Title = styled.div`
  font-family: BrandonGrotesque-Medium;
  font-size: 14px;
  font-weight: bold;
  font-style: italic;
  line-height: 40px;
  margin-left: 30px;
  color: #994f4f;
`;

const Awaiting = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  line-height: 40px;
  color: #994f4f;
  text-decoration: underline;
  cursor: pointer;
`;

interface Props {
  offer: Offer;
  type: string;
}

function ReservationBucket({ offer, type }: Props) {
  const awaiting = offer.awaitings || [];
  const [showAwaiting, flip] = useState(false);

  return (
    <InstanceContainer>
      <Row>
        <Col size="0 0 191px">
          <Title>Reservation Required</Title>
        </Col>
        <Col size="0 0 79px">
          {!offer.canceled_at ? (
            <ClaimNumber style={{ textDecoration: 'none' }}>
              <span style={{ fontFamily: 'BrandonGrotesque-Bold' }}>
                {offer.taken_spots}/{offer.available_spots === -1 ? '∞' : offer.available_spots}{' '}
              </span>{' '}
              Claims
            </ClaimNumber>
          ) : null}
        </Col>
        <Col size="0 0 113px">
          {offer.waitlist_spots ? (
            <WaitlistInfo>{offer.waitlist_spots} on waitlist</WaitlistInfo>
          ) : null}
        </Col>
        <Col size="1">
          {!offer.canceled_at && awaiting.length ? (
            <Awaiting onClick={() => flip(true)}>
              <b>{awaiting.length}</b> Awaiting Reservations
            </Awaiting>
          ) : null}
          {showAwaiting ? (
            <AttendeeList attendees={awaiting} close={() => flip(false)} offer={offer} />
          ) : null}
        </Col>
      </Row>
    </InstanceContainer>
  );
}

export default ReservationBucket;
